/**
 * 动态设置根元素字体大小
 * 1rem = 页面宽度的1/10
 */
(function() {
  // 设置最大最小限制
  const MAX_FONT_SIZE = 64
  const MIN_FONT_SIZE = 12
  
  function setRootFontSize() {
    // 获取视口宽度
    const width = document.documentElement.clientWidth || window.innerWidth
    // 计算字体大小 (视口宽度的1/20)
    let fontSize = width / 20
    // 应用限制
    fontSize = Math.min(MAX_FONT_SIZE, Math.max(MIN_FONT_SIZE, fontSize))
    // 设置根元素字体大小
    document.documentElement.style.fontSize = fontSize + 'px'
  }

  // 初始化执行
  setRootFontSize()
  
  // 防抖函数
  function debounce(fn, delay) {
    let timer = null
    return function() {
      if (timer) clearTimeout(timer)
      timer = setTimeout(fn, delay)
    }
  }
  
  // 监听窗口大小变化
  window.addEventListener('resize', debounce(setRootFontSize, 300))
})()